import { EventType } from '@/analytics/types';
import type { TextColProps } from '@/app/components/TwoColumnModule';
import TwoColumnModule from '@/app/components/TwoColumnModule';

import { motionProps, textCol } from './_data/metabolicSpecsData';

const MetabolicHealthSpecsCta = () => {
  const href = '/store/dexcom/stelo-glucose-biosensor';
  const handleClick = async (): Promise<void> => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'shop stelo',
      cta: 'Shop Stelo',
      location: 'body',
      path: href,
    });
  };
  const buttonProps: TextColProps['buttonProps'] = {
    label: 'shop_stelo',
    className: 'w-fit',
    variant: 'primary',
    href: href,
    onClick: () => handleClick(),
  };
  return (
    <div className="relative pb-20" data-cy="metabolic-health-specs-cta">
      <TwoColumnModule
        imageCol={{
          src: 'metabolic_health_specs',
          localizedAlt: 'dexcom_phone_feature_alt',
          motionProps,
        }}
        smBreakTextPos="bottom"
        mdBreakTextPos="left"
        textCol={{ ...textCol, buttonProps }}
      />
    </div>
  );
};

export default MetabolicHealthSpecsCta;
